export enum ActivityStreamEntity {
    Comment = 'Comment',
    Email = 'Email',
    OmEmeaRequest = 'OmEmeaRequest',
    Approval = 'Approval',
    Attachment = 'Attachment'
}
